<template>
  <div class="p-3 card">
    <label class="titlePage">Configuração da Publicação</label>
    <table class="table table-bordered table-condensed table-striped table-hover relatorio">
      <tr>
        <th scope="col" class="col-1">SPI</th>
        <th scope="col" class="col-1">Fase</th>
        <th scope="col" class="col-1">Aplicação</th>
        <th scope="col" class="col-1" v-if="criarConfiguracao">Solicitação</th>
        <th scope="col" class="col-1" v-if="criarConfiguracao">Data Inicial de Acesso</th>
        <th scope="col" class="col-1" v-if="criarConfiguracao">Data Final de Acesso</th>
      </tr>
      <tr>
        <td>
          <fcc-select
            label-field="spi"
            value-field="spi"
            v-model="spi"
            :options="listaSpis"
            :clearable="false"
            :disabled="criarConfiguracao"
            required
          />
        </td>
        <td>
          <fcc-select
            label-field="fase"
            value-field="fase"
            v-model="idFase"
            :options="listaFases"
            :clearable="false"
            :disabled="!spi || criarConfiguracao"
            required
          />
        </td>
        <td>
          <fcc-select
            label-field="aplicacao"
            value-field="aplicacao"
            v-model="idAplic"
            :options="listaAplicacoes"
            :clearable="false"
            :disabled="!spi || !idFase || criarConfiguracao"
            required
          />
        </td>
        <td v-if="criarConfiguracao">
          <fcc-select
            label-field="solicitacao"
            value-field="solicitacao"
            v-model="idSolicitacao"
            :options="listaSolicitacoes"
            :clearable="false"
            :disabled="!spi"
            required
          />
        </td>
        <td v-if="criarConfiguracao">
          <fccDateInput type="datetime" v-model="dataInicioAcesso" required />
        </td>
        <td v-if="criarConfiguracao">
          <fccDateInput type="datetime" v-model="dataFimAcesso" required />
        </td>
      </tr>
    </table>

    <div class="text-right mb-3">
      <fccButton @click="cancelarCriacao" v-if="criarConfiguracao" class="mr-2">Cancelar</fccButton>
      <fccButton
        @click="salvarConfiguracaoDaPublicacao"
        :disabled="!todosCamposSelecionados"
        v-if="criarConfiguracao"
        >{{ labelsSystem.salvar }}</fccButton
      >
      <fccButton
        @click="buscarConfiguracaoDaPublicacao"
        :disabled="!todosCamposPrincipaisSelecionados"
        v-else
        >{{ labelsSystem.buscar }}</fccButton
      >
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import store from '../../../../../store'
import fccConfiguracaoPublicacaoMixin from '../fccConfiguracaoDePublicacao/fccConfiguracaoPublicacaoMixin'

export default {
  mixins: [fccConfiguracaoPublicacaoMixin],
  data() {
    return {
      criarConfiguracao: false,
      listaSpis: []
    }
  },
  created() {
    this.listarSPI()
  },
  methods: {
    listarSPI() {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          store.state.baseUrlPublicacao + 'Publicacao/ListarPublicacaoSpis',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          this.loading = false
          this.listaSpis = response.data.map((item) => {
            return {
              spi: item
            }
          })
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto())
    },
    salvarConfiguracaoDaPublicacao() {
      const { dataConfig, ...rest } = this.configuracaoDaPublicacao
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .post(
          store.state.baseUrlLocalDeProva + 'LocalExameConfig/Inserir',
          rest,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          store.dispatch(
            'localDeProva/fetchConfiguracao',
            response.data,
            this.dadosLoginSession.fccTokenHeaders
          )
          this.criarConfiguracao = false
          this.limparCampos()
          this.carregaTexto()
        })
        .catch(this.setErrorSystem)
    },
    buscarConfiguracaoDaPublicacao() {
      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .get(
          store.state.baseUrlLocalDeProva +
            `LocalExameConfig/GetBySpiIdFaseIdAplic/${this.spi}/${this.idFase}/${this.idAplic}`,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then((response) => {
          if (response.data.length > 0) {
            store.dispatch(
              'localDeProva/fetchConfiguracao',
              response.data[0].idlocalconfig,
              this.dadosLoginSession.fccTokenHeaders
            )
            this.limparCampos()
            this.carregaTexto()
          } else {
            this.carregaTexto()
            this.callConfirm(
              'A configuração da publicação não foi encontrada. Deseja criar uma nova?',
              ''
            ).then((result) => {
              if (result.value) {
                this.criarConfiguracao = true
                store.commit('localDeProva/RESET_STORE')
              }
            })
          }
        })
        .catch(this.setErrorSystem)
    },
    cancelarCriacao() {
      this.criarConfiguracao = false
      this.limparCampos()
    }
  }
}
</script>
